import { useContext } from "react";
import { EmbedContext } from "../embed-context";

export const useEmbed = () => {
    const { isEmbed } = useContext(EmbedContext);
    return { isEmbed };
};
